import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum AmaronOus {
    "Country" = "db77d480-fd2b-41e0-8e10-171a710f0d2b",
    "State" = "2307e157-abed-47fb-928e-46e84bba1cb3",
    "Pincode" = "d193ca98-8095-48ea-b090-5270c38740ac",
}

export const AMARON__OU__COUNTRY__NAME__COLUMN_ID = "a56dee1f-c932-4f2c-9b49-7432edff9ea1" as Uuid;

export const AMARON__OU__STATE__NAME__COLUMN_ID = "829afc9c-5291-472e-af7e-8298b19fbd70" as Uuid;

export const AMARON__OU__PINCODE__NAME__COLUMN_ID = "372e08df-c1f3-43c5-9736-5f12a0ce53e5" as Uuid;
